import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import RegionDropdown from 'cirrus/Dropdown/Region';
import { hasRegions } from 'cirrus/Dropdown/Region/utils';

const AddressRegion = ({
  name,
  countryCode,
  regionName,
  regionCode,
  onSelectChange,
  onChange,
  onKeyPress,
  dropdownClassName,
  className,
  inputProps,
  ...rest
}) => (
  <Fragment>
    {hasRegions(countryCode) ? (
      <Fragment>
        <RegionDropdown
          className={dropdownClassName}
          countryCode={countryCode}
          regionName={regionName}
          regionCode={regionCode}
          onChange={onSelectChange}
          inputProps={inputProps}
          {...rest}
        />
        <input name={`${name}`} type="hidden" className={className} readOnly value={regionName} />
      </Fragment>
    ) : (
      <input
        data-test="region-input"
        type="text"
        name={name}
        autoComplete="off"
        value={regionName}
        size="30"
        maxLength="255"
        onChange={onChange}
        onKeyPress={onKeyPress}
        {...rest}
        className={className}
        style={{ height: '32px', lineHeight: '32px' }}
      />
    )}
    <input name={`${name}_code`} type="hidden" className={className} readOnly value={regionCode} />
  </Fragment>
);

AddressRegion.defaultProps = {
  countryCode: '',
  regionName: '',
  regionCode: '',
};

AddressRegion.propTypes = {
  name: PropTypes.string.isRequired,
  countryCode: PropTypes.string,
  regionName: PropTypes.string,
  regionCode: PropTypes.string,
};

export default AddressRegion;
